export default __webpack_public_path__ + "static/media/table_view_icon_enabled.112b5c32.svg";